// extracted by mini-css-extract-plugin
export default {"container":"jp-z","heading":"kp-z","text":"lp-z","info":"mp-z","link":"np-z","fullMaxWidth":"op-z"};